import { Translate } from 'react-localize-redux-dep-updated';
import { FlashMessage } from '../../../../../brenger-shared-ui';
import * as React from 'react';
import { toggleChat } from '../../HelpModal';
import { getActiveLanguageSettings } from '../../../../../utils/localization';

export const AddressError: React.FC = () => {
  const langSettings = getActiveLanguageSettings();
  const [showContact, setShowContact] = React.useState(false);

  if (showContact === false) {
    return (
      <FlashMessage type="info">
        <Translate
          id="request_flow.address_error.cta_to_contact"
          data={{
            contact_us: (
              <span onClick={() => setShowContact(true)} className="cursor-pointer trigger underline">
                <Translate id="request_flow.address_error.contact_cta" />
              </span>
            ),
          }}
        />
      </FlashMessage>
    );
  }

  return (
    <FlashMessage type="info">
      <Translate
        id="request_flow.address_error.contact_options"
        data={{
          phone: (
            <div style={{ display: 'inline-block' }}>
              <a href={`tel:${langSettings.contact.phone.customer}`}>{langSettings.contact.phone.customer}</a>
            </div>
          ),
          chat: (
            <span onClick={() => toggleChat()} className="cursor-pointer trigger underline">
              chat
            </span>
          ),
        }}
      />
    </FlashMessage>
  );
};
